import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import config from "../config";
import axios from "axios";
import Field from "../sections/MUI/Field";
import File from "../sections/MUI/File";
import Select from "../sections/MUI/Select";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";

class EditCategory extends Component {

    state = {
        id: "",
        title: "",
        image: null,
        description: "",
        parent: "",

        categories: {
            all: [],
            categories: null,
            cascaderCategories: []
        },
    };

    componentDidMount() {
        config.scrollTop();
        this.getCategories();
        this.getCategory();
    }


    getCategory() {
        axios.get(`${config.api}/admin/category?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                const {id, title, meta, parent} = r.data.result;
                this.setState({
                    id,
                    title,
                    description: meta.description,
                    parent
                })
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getCategories() {
        axios.get(`${config.api}/admin/categories?token=${config.token}`)
            .then(r => {
                this.setState({
                    categories: r.data
                });
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    edit() {
        const {id, title, description, image, parent} = this.state;
        if (title !== "" && description !== "") {
            let params = new FormData();
            params.append("editId", id);
            params.append("title", title);
            params.append("meta", JSON.stringify({
                description
            }));
            if (image) {
                params.append('image', image);
            }
            toast.info("در حال ویرایش ...");
            axios.put(`${config.api}/admin/category?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    toast.success("با موفقیت ویریش شد");
                    this.getCategory()
                })
                .catch(err => {

                });
        } else {
            toast.error("فیلد ها را به درستی وارد کنید")
        }
    }

    delete() {
        const {id} = this.state;
        toast.info("در حال حذف ...")
        axios.delete(`${config.api}/admin/category?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.props.navigate(-1);
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    render() {
        const {id, title, image, description, categories} = this.state;
        return (
            <div className="edit-category">
                <Back {...this.props}/>
                <div className="row">
                    <div className="col-md-6">
                        <Field name="title"
                               value={title}
                               label="عنوان"
                               maxLength={255}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">
                        <File
                            value={image}
                            label="عکس"
                            name="image"
                            multiple={false}
                            accept="image/*"
                            onChange={(name, value) => this.setState({image: value})}/>
                    </div>


                    <div className="col-md-6">
                        <Field name="description"
                               value={description}
                               label="توضیحات متا"
                               type="textarea"
                               row={3}
                               onChange={(name, value) => this.setState({[name]: value})}/>
                    </div>
                    <div className="col-md-6">

                    </div>
                </div>

                <div className="row justify-content-between">
                    <div className="col-md-5">
                        <Button submit={false} icon="edit"
                                onClick={() => this.edit()}>ویرایش کردن</Button>
                    </div>
                    <div className="col-md-5">
                        <Button submit={false}
                                backgroundColor="#D32F2F"
                                icon="trash"
                                onDoubleClick={() => this.delete()}>حذف (دوبار کلیک)</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(EditCategory);